import React, { Component } from 'react';
import ImportRatePlan from '../../components/adminComponents/importExportRatePlan/importRatePlan';
import ExportRatePlan from '../../components/adminComponents/importExportRatePlan/exportRatePlan';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

class ImportExportRatePlan extends Component {
             state = {
                  }

render() {
    return(<>
    <div className="page-header">
					<div className="row mb-10">
						<div className="col-md-6 col-sm-12">
							<div className="title">
								<h4>Import/Export Rate Plan</h4>
							</div>
						</div>
				</div>
			</div>
    <div className="row">
        <div className="col-sm-12 col-md-6">
            <div className="card">
                <div className="card-header">
                  Import Rate Plans
                </div>
                <div className="card-body">
                  <ImportRatePlan  
                  />
                </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-6">
            <div className="card">
                <div className="card-header">
                  Export Rate Plans
                </div>
                <div className="card-body">
                  <ExportRatePlan
                  accountTypes={this.props.accountTypes} 
                   />                  
                </div>
              </div>
            </div> 
        </div>
    </>)
  }
}
const mapStateToProps = (state, ownProps) => {
	return {
		authInfo: state.authInfo,
		refNotify: state.refNotify,
		accountTypes: state.accountTypes.accountTypes, 
  }
}
export default withRouter(connect(mapStateToProps)(ImportExportRatePlan));
